import { render, staticRenderFns } from "./PageKLabel.vue?vue&type=template&id=5e0a8c46"
import script from "./PageKLabel.vue?vue&type=script&lang=js"
export * from "./PageKLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports